import Constants from "./Constants";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

export const isoStringToFormat = (value: any, format: string) => {
  if (!value) return "---";

  if (format === Constants.FIELDTYPES.DATE_TIME) {
    if (!isNaN(value)) {
      const d = new Date();

      d.setTime(value * 1000);

      value = d.toISOString();
    }

    const now = dayjs(value);
    return now.tz(dayjs.tz.guess()).format("lll");
  }

  if (format === Constants.FIELDTYPES.DATE) {
    if (!isNaN(value)) {
      const d = new Date();

      d.setTime(value * 1000);

      value = d.toISOString();
    }

    const now = dayjs(value);

    return now.format("ll");
  }

  if (format === Constants.FIELDTYPES.TIME) {
    if (!isNaN(value)) {
      const d = new Date();

      d.setTime(value * 1000);

      value = d.toISOString();
    }

    const now = dayjs(value, "HH:mmZZ");

    return now.tz(dayjs.tz.guess()).format("h:mm A");
  }
};
